/**
 * Labels and helpers for the club economy ledger (Klubbdrift → Økonomi).
 * Keep the category keys in sync with backend/lib/club-ledger.js.
 */
export const EXPENSE_CATEGORIES = [
    { key: 'ammunition', label: 'Ammunisjon' },
    { key: 'rangeMaintenance', label: 'Banevedlikehold' },
    { key: 'equipment', label: 'Utstyr' },
    { key: 'competitions', label: 'Stevner og reise' },
    { key: 'fees', label: 'Avgifter og lisenser' },
    { key: 'other', label: 'Annet' },
];

export const INCOME_CATEGORIES = [
    { key: 'grants', label: 'Tilskudd' },
    { key: 'sponsorship', label: 'Sponsor' },
    { key: 'membershipFees', label: 'Medlemskontingent' },
    { key: 'other', label: 'Annet' },
];

export const SALE_GROUP_LABELS = {
    ammo: 'Ammo-salg',
    convention: 'Stevnepåmeldinger',
    webshop: 'Nettbutikk',
};

export function categoriesFor(type) {
    return type === 'income' ? INCOME_CATEGORIES : EXPENSE_CATEGORIES;
}

export function categoryLabel(key) {
    const found = [...EXPENSE_CATEGORIES, ...INCOME_CATEGORIES].find(c => c.key === key);
    return found ? found.label : key;
}

export function formatNok(value) {
    return new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 2 }).format(Number(value) || 0);
}

export function yearOptions(now = new Date()) {
    const current = now.getFullYear();
    return [current, current - 1, current - 2, current - 3, current - 4];
}
